import { IIcon } from '@rbilabs/components-library/build/themes';

import type { TLocalizationKey } from 'types/i18n';

import { StoreLocatorViews } from '../types';

export interface IToggleViewButtonProps {
  currentView: StoreLocatorViews;
  updateStoreLocatorView: (newValue: StoreLocatorViews) => void;
  className?: string;
}

export type ViewIconMap = Record<StoreLocatorViews, keyof IIcon>;

// the values seem swapped because if we are on the
// list view we want to show the map icon & message
export const VIEW_ICON_MAP: ViewIconMap = {
  [StoreLocatorViews.LIST_VIEW]: 'map',
  [StoreLocatorViews.MAP_VIEW]: 'list',
};

// the values seem swapped because if we are on the
// list view we want to show the map icon & message
export const VIEW_MESSAGE_ID_MAP: Record<StoreLocatorViews, TLocalizationKey> = {
  [StoreLocatorViews.LIST_VIEW]: 'map',
  [StoreLocatorViews.MAP_VIEW]: 'list',
};
